import React from "react";
import useStyles from "./termsStyling";

const TermsOfServices = () => {
  const classes = useStyles();
  return (
    <div
      style={{
        width: "90%",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "10%",
      }}
    >
      <h1 className={classes.title}>Rules and Regulations</h1>

      <h3 className={classes.heading}>Effective Date:6 Nov 2020</h3>

      <h3 className={classes.heading}>
        Hello and Welcome to the Privacy Policies
      </h3>

      <p className={classes.paragraph}>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Molestias aut,
        repellat ipsum facere voluptate dicta obcaecati deserunt nobis suscipit
        eaque? Lorem, ipsum dolor sit amet consectetur adipisicing elit.
        Molestias aut, repellat ipsum facere voluptate dicta obcaecati deserunt
        nobis suscipit eaque?Lorem, ipsum dolor sit amet consectetur adipisicing
        elit. Molestias aut, repellat ipsum facere voluptate dicta obcaecati
        deserunt nobis suscipit eaque? Lorem, ipsum dolor sit amet consectetur
        adipisicing elit. Molestias aut, repellat ipsum facere voluptate dicta
        obcaecati deserunt nobis suscipit eaque?
      </p>

      <h3 className={classes.heading}>01.Heading?</h3>

      <p className={classes.paragraph}>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Molestias aut,
        repellat ipsum facere voluptate dicta obcaecati deserunt nobis suscipit
        eaque? Lorem, ipsum dolor sit amet consectetur adipisicing elit.
        Molestias aut, repellat ipsum facere voluptate dicta obcaecati deserunt
        nobis suscipit eaque?Lorem, ipsum dolor sit amet consectetur adipisicing
        elit. Molestias aut, repellat ipsum facere voluptate dicta obcaecati
        deserunt nobis suscipit eaque? Lorem, ipsum dolor sit amet consectetur
        adipisicing elit. Molestias aut, repellat ipsum facere voluptate dicta
        obcaecati deserunt nobis suscipit eaque?Lorem, ipsum dolor sit amet
        consectetur adipisicing elit. Molestias aut, repellat ipsum facere
        voluptate dicta obcaecati deserunt nobis suscipit eaque? Lorem, ipsum
        dolor sit amet consectetur adipisicing elit. Molestias aut, repellat
        ipsum facere voluptate dicta obcaecati deserunt nobis suscipit
        eaque?Lorem, ipsum dolor sit amet consectetur adipisicing elit.
        Molestias aut, repellat ipsum facere voluptate dicta obcaecati deserunt
        nobis suscipit eaque? Lorem, ipsum dolor sit amet consectetur
        adipisicing elit. Molestias aut, repellat ipsum facere voluptate dicta
        obcaecati deserunt nobis suscipit eaque?
      </p>

      <h3 className={classes.heading}>02.Heading?</h3>

      <p className={classes.paragraph}>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Molestias aut,
        repellat ipsum facere voluptate dicta obcaecati deserunt nobis suscipit
        eaque? Lorem, ipsum dolor sit amet consectetur adipisicing elit.
        Molestias aut, repellat ipsum facere voluptate dicta obcaecati deserunt
        nobis suscipit eaque?Lorem, ipsum dolor sit amet consectetur adipisicing
        elit. Molestias aut, repellat ipsum facere voluptate dicta obcaecati
        deserunt nobis suscipit eaque? Lorem, ipsum dolor sit amet consectetur
        adipisicing elit. Molestias aut, repellat ipsum facere voluptate dicta
        obcaecati deserunt nobis suscipit eaque?Lorem, ipsum dolor sit amet
        consectetur adipisicing elit. Molestias aut, repellat ipsum facere
        voluptate dicta obcaecati deserunt nobis suscipit eaque? Lorem, ipsum
        dolor sit amet consectetur adipisicing elit. Molestias aut, repellat
        ipsum facere voluptate dicta obcaecati deserunt nobis suscipit
        eaque?Lorem, ipsum dolor sit amet consectetur adipisicing elit.
        Molestias aut, repellat ipsum facere voluptate dicta obcaecati deserunt
        nobis suscipit eaque? Lorem, ipsum dolor sit amet consectetur
        adipisicing elit. Molestias aut, repellat ipsum facere voluptate dicta
        obcaecati deserunt nobis suscipit eaque?
      </p>

      <h3 className={classes.heading}>03.Heading?</h3>

      <p className={classes.paragraph}>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Molestias aut,
        repellat ipsum facere voluptate dicta obcaecati deserunt nobis suscipit
        eaque? Lorem, ipsum dolor sit amet consectetur adipisicing elit.
        Molestias aut, repellat ipsum facere voluptate dicta obcaecati deserunt
        nobis suscipit eaque?Lorem, ipsum dolor sit amet consectetur adipisicing
        elit. Molestias aut, repellat ipsum facere voluptate dicta obcaecati
        deserunt nobis suscipit eaque? Lorem, ipsum dolor sit amet consectetur
        adipisicing elit.{" "}
      </p>

      <h3 className={classes.heading}>04.Heading?</h3>

      <p className={classes.paragraph}>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Molestias aut,
        repellat ipsum facere voluptate dicta obcaecati deserunt nobis suscipit
        eaque? Lorem, ipsum dolor sit amet consectetur adipisicing elit.
        Molestias aut, repellat ipsum facere voluptate dicta obcaecati deserunt
        nobis suscipit eaque?Lorem, ipsum dolor sit amet consectetur adipisicing
        elit. Molestias aut, repellat ipsum facere voluptate dicta obcaecati
        deserunt nobis suscipit eaque? Lorem, ipsum dolor sit amet consectetur
        adipisicing elit.
      </p>
    </div>
  );
};

export default TermsOfServices;
